export default __webpack_public_path__ + "static/media/customer3.474dd03c.svg";